import React, { useState } from 'react'
import {
	Alert,
	Button,
	Group,
	Modal,
	Select,
	Stack,
	Text,
	TextInput,
} from '@mantine/core'

const StaffAssignmentModal = ({ users, stationOptions, onClose, onSave }) => {
	const [level, setLevel] = useState('staff')
	const [positionName, setPositionName] = useState('Staff')
	const [station, setStation] = useState(null)
	const [saving, setSaving] = useState(false)
	const [error, setError] = useState('')

	const handleSubmit = async (event) => {
		event.preventDefault()
		if (saving) return
		if (!positionName.trim()) {
			setError('Enter a position name.')
			return
		}
		setError('')
		setSaving(true)
		try {
			await onSave({
				level,
				positionName: positionName.trim(),
				station: station || '',
			})
		} catch (err) {
			setError(err.message || 'Failed to add staff. Please try again.')
		} finally {
			setSaving(false)
		}
	}

	return (
		<Modal
			opened
			onClose={() => {
				if (!saving) onClose()
			}}
			title={
				users.length === 1 ? 'Add staff' : `Add ${users.length} users to staff`
			}
			centered
			closeOnClickOutside={!saving}
			closeOnEscape={!saving}
			withCloseButton={!saving}
		>
			<form aria-label='Staff assignment' onSubmit={handleSubmit}>
				<Stack spacing='md'>
					<Text size='sm'>
						{users.map((user) => user.name || user.email).join(', ')}
					</Text>
					{users.length > 1 && (
						<Text size='sm' color='dimmed'>
							These settings apply to all selected users.
						</Text>
					)}
					{error && (
						<Alert color='red' title='Staff not added'>
							{error}
						</Alert>
					)}
					<Select
						label='Position level'
						withAsterisk
						value={level}
						onChange={(value) => {
							setLevel(value)
							if (
								!positionName ||
								positionName === 'Staff' ||
								positionName === 'Owner'
							) {
								setPositionName(value === 'owner' ? 'Owner' : 'Staff')
							}
						}}
						data={[
							{ value: 'staff', label: 'Staff' },
							{ value: 'owner', label: 'Owner' },
						]}
						allowDeselect={false}
						disabled={saving}
					/>
					<TextInput
						label='Position name'
						value={positionName}
						onChange={(event) => setPositionName(event.target.value)}
						required
						error={
							!positionName.trim() && error
								? 'Position name is required.'
								: null
						}
						disabled={saving}
					/>
					<Select
						label='Station'
						placeholder='No station'
						description={
							stationOptions?.length === 0 &&
							'No stations configured. You can add staff without a station.'
						}
						value={station}
						onChange={setStation}
						data={stationOptions.map((option) => ({
							value: option.id,
							label: option.name,
						}))}
						searchable
						clearable
						disabled={saving || stationOptions.length === 0}
					/>
					<Group position='right'>
						<Button variant='default' disabled={saving} onClick={onClose}>
							Cancel
						</Button>
						<Button type='submit' loading={saving}>
							{users.length === 1 ? 'Add staff' : `Add ${users.length} users`}
						</Button>
					</Group>
				</Stack>
			</form>
		</Modal>
	)
}

export default StaffAssignmentModal
